// deviceLoader.js
export function getDeviceInfo(runtime, setDeviceInfo) {
  const _KEY = "_device_id";
  const _KEY_NAME = "_device_name";
  const _getDeviceId = () => localStorage.getItem(_KEY);
  const _setDeviceId = (device_id) => localStorage.setItem(_KEY, device_id);
  const _getDeviceName = () => localStorage.getItem(_KEY_NAME);
  const _setDeviceName = (device_name) =>
    localStorage.setItem(_KEY_NAME, device_name);
  const _generateReadableName = () => {
    const adjectives = [
      "Brave",
      "Quiet",
      "Swift",
      "Clever",
      "Bold",
      "Charming",
      "Happy",
      "Witty",
    ];
    const nouns = [
      "Fox",
      "Tiger",
      "Panda",
      "Wolf",
      "Hawk",
      "Otter",
      "Eagle",
      "Koala",
    ];
    const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const suffix = Math.floor(100 + Math.random() * 900);
    return `${adjective}${noun}-${suffix}`;
  };
  switch (runtime) {
    case "electron": {
      const { machineIdSync } = require("node-machine-id");
      const os = require("os");
      const device_id = `kds-${machineIdSync({ original: true })}`;
      const device_name = os.hostname();
      const osInfo = `${os.platform()}`;
      setDeviceInfo(device_id, device_name, osInfo);
      return;
    }
    case "cordova": {
      let device_id = _getDeviceId();
      let device_name = _getDeviceName();
      let os;

      const _set = (device) => {
        if (!device) {
          return;
        }
        device_id = `kds-${device.uuid}`;
        device_name = `${device.manufacturer}/${_generateReadableName()}`;
        os = `${device.platform}@${device.version}`;

        _setDeviceId(device_id);
        _setDeviceName(device_name);
        return { device_id, device_name, os };
      };
      if (!device_id) {
        console.log({ window });
        if (window.device) {
          _set(window.device);
        } else {
          document.addEventListener("deviceready", () => {
            _set(window.device);
            setDeviceInfo(device_id, device_name, os);
          });
        }
      }

      setDeviceInfo(device_id, device_name, os);
      return;
    }
    default: {
      const getOSFromUserAgent = () => {
        const ua = navigator.userAgent;
        if (/Windows NT/.test(ua)) return "win32";
        if (/Mac OS X/.test(ua)) return "darwin";
        if (/Linux/.test(ua)) return "linux";
        if (/Android/.test(ua)) return "android";
        if (/iPhone|iPad|iPod/.test(ua)) return "ios";
        return "unknown";
      };

      let device_id = _getDeviceId();
      if (!device_id) {
        device_id = `kds-${crypto.randomUUID()}`;
        _setDeviceId(device_id);
      }

      let deviceName = _getDeviceName();
      if (!deviceName) {
        deviceName = _generateReadableName();
        _setDeviceName(deviceName);
      }

      setDeviceInfo(device_id, deviceName, getOSFromUserAgent());
    }
  }
}

export default getDeviceInfo;
